import React from 'react';

import { PortalDetailComp } from './components';

export function PortalDetail(): JSX.Element {
    return <PortalDetailComp />;
}
